import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";

import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";
import { verifyAgentAccess } from "../store/slices/misc/agentAccess";
import { verifySmartMapperAccess } from "../store/slices/misc/smartMapperAccess";
import { fetchSequenceAccess } from "../store/slices/misc/sequenceAccess";
import { updateMenuData } from "../store/slices/misc/menuData";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import { HomeOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import NotificationMain from "../pages/notifications/NotificationMain";
import Faq from "../pages/others/Faq";
import Terms from "../pages/others/Terms";
import SetPassword from "../pages/auth/SetPassword";
import SuccessMain from "../pages/auth/SuccessMain";
import EmailError from "../pages/auth/EmailError";
import ResetPassword from "../pages/auth/ResetPassword";
import { Flex, Spin } from "antd";
import TenderManagementDashboard from "../pages/TenderManagement/dashboard";
import NewTenderMain from "../pages/TenderManagement/NewTender/NewTenderMain";
import AllTendersList from "../pages/TenderManagement/TenderList/AllTendersList";
import BAFOList from "../pages/TenderManagement/TenderList/BAFOList";
import BAFOAnalysisView from "../pages/TenderManagement/BAFOAnalysis/View";
import TenderPendingApprovalsList from "../pages/TenderManagement/TenderList/TenderPendingApprovalsList";
import ViewTenderById from "../pages/TenderManagement/TenderDetailsView/ViewTenderById";
import TenderEvaluation from "../pages/TenderManagement/TenderEvaluation/TenderEvaluation";
import SupplierDetailsPage from "../pages/TenderManagement/TenderEvaluation/SupplierDetailsPage";
import SupplierViewPage from "../pages/TenderManagement/TenderEvaluation/SupplierViewPage";
import ContractList from "../pages/TenderManagement/Contracts/ContractsList";
import ContractsView from "../pages/TenderManagement/Contracts/ContractsView";
//Procurex Pages

// Masters imports
import ViewOrgPage from "../pages/masters/orgmaster/ViewOrg";
import OrgLegalInformation from "../pages/masters/orgmaster/OrgLegalInformation";
import OrgContactInformation from "../pages/masters/orgmaster/orgContactInformation";
import OrgBankInformation from "../pages/masters/orgmaster/OrgBankInformation";
import SitesSetup from "../pages/masters/sites/SitesSetup";
import AddSites from "../pages/masters/sites/CreateSites";
import SitesViewDetails from "../pages/masters/sites/SitesViewDetails";
import DeliveryAddress from "../pages/masters/delivery-address/DeliveryAddress";
import SequenceList from "../pages/masters/sequence/SequenceList";
import Departments from "../pages/masters/departments/Departments";
import Roles from "../pages/masters/roles/Roles";
import RoleViewDetails from "../pages/masters/roles/ViewRole";
import CreateRole from "../pages/masters/roles/CreateRole";
import ReportingHeirarchy from "../pages/masters/roles/ReportingHeirarchy";
import ApprovalHeirarchy from "../pages/masters/contractors/ApprovalHeirarchy";
import SupplierCategory from "../pages/masters/supplier/SupplierCategory";
import Suppliers from "../pages/masters/supplier/Suppliers";
import AddSupplier from "../pages/masters/supplier/AddSupplier";
import ViewSuppliersDetails from "../pages/masters/supplier/ViewSuppliersDetails";
import Contractors from "../pages/masters/contractors/Contractors";
import AddContractors from "../pages/masters/contractors/AddContractors";
import ViewContractorDetails from "../pages/masters/contractors/ViewContractorDetails";
import Clients from "../pages/masters/clients/Clients";
import AddClients from "../pages/masters/clients/AddClients";
import ViewClientDetails from "../pages/masters/clients/ViewClientDetails";
import Consultants from "../pages/masters/consultants/Consultants";
import AddConsultants from "../pages/masters/consultants/AddConsultants";
import ViewConsultantDetails from "../pages/masters/consultants/ViewConsultantDetails";
import Users from "../pages/masters/Users/Users";
import CreateUsers from "../pages/masters/Users/CreateUsers";
import UserViewDetails from "../pages/masters/Users/ViewUser";
import MaterialCategory from "../pages/masters/materials/MaterialCategory";
import Materials from "../pages/masters/materials/Material";
import AddMaterial from "../pages/masters/materials/AddMaterial";
import ViewMaterialDetails from "../pages/masters/materials/ViewMaterialDetails";
import UomPage from "../pages/masters/Uom/UomPage";
import CostCenter from "../pages/masters/cost-center/CostCenter";
import GeneralLedger from "../pages/masters/general-ledger/GeneralLedger";
import TaxMaster from "../pages/masters/taxmaster/TaxMaster";
import LabourMaster from "../pages/masters/labourmaster/LabourMaster";
import GateEntry from "../pages/masters/gateentry/GateEntry";
import ToolMaster from "../pages/masters/toolmaster/ToolMaster";
import BrandMaster from "../pages/masters/brandmaster/BrandMaster";
import LocationMaster from "../pages/masters/locationmaster/LocationMaster";
import SiteMaster from "../pages/masters/sitebreakdownmaster/SiteMaster";
import SiteMasterFormImproved from "../pages/masters/sitebreakdownmaster/SiteMasterFormImproved";
import SitesStructureViewDetails from "../pages/masters/sitebreakdownmaster/SitesViewDetails";
import WorkCategory from "../pages/masters/WorkCategory/WorkCategory";
import WorkUom from "../pages/masters/WorkUom/WorkUom";
import Settings from "../pages/masters/settings/Settings";

const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  // "/notifications",
];

const tenderManagementRouts = {
  "tender/dashboard": <TenderManagementDashboard />,
  "tender/new-tender": <NewTenderMain />,
  "tender/tender-list": <AllTendersList />,
  "tender/bafo-list": <BAFOList />,
  "tender/pending-approvals": <TenderPendingApprovalsList />,
  "tender/bafo-analysis/:tenderID": <BAFOAnalysisView />,
  "tender/view-tender/:tenderID": <ViewTenderById />,
  "tender-evaluation": <TenderEvaluation />,
  "contract-list": <ContractList />,
  "contracts-view/:id": <ContractsView />,

  // Masters routes
  organisation: <ViewOrgPage />,
  orgLegalInformation: <OrgLegalInformation />,
  orgContactInformation: <OrgContactInformation />,
  orgBankInformation: <OrgBankInformation />,
  sites: <SitesSetup />,
  createSites: <AddSites />,
  "delivery-address": <DeliveryAddress />,
  sequence: <SequenceList />,
  "sitesViewDetails/:siteId": <SitesViewDetails />,
  departments: <Departments />,
  roles: <Roles />,
  "ViewRoleDetails/:roleID": <RoleViewDetails />,
  "reporting-hierarchy": <ReportingHeirarchy />,
  "supplier-category": <SupplierCategory />,
  "work-category": <WorkCategory />,
  "work-uom": <WorkUom />,
  suppliers: <Suppliers />,
  addSuppliers: <AddSupplier />,
  "vewSuppliersDetails/:siteId": <ViewSuppliersDetails />,
  "general-contractors": <Contractors />,
  "viewContractorDetails/:siteId": <ViewContractorDetails />,
  addContractors: <AddContractors />,
  clients: <Clients />,
  addClients: <AddClients />,
  "viewClientDetails/:siteId": <ViewClientDetails />,
  addConsultants: <AddConsultants />,
  "viewConsultantDetails/:consultantId": <ViewConsultantDetails />,
  addMaterials: <AddMaterial />,
  "vewMaterialDetails/:materialId": <ViewMaterialDetails />,
  consultants: <Consultants />,
  users: <Users />,
  createUsers: <CreateUsers />,
  "userProfile/:userId": <UserViewDetails />,
  createRole: <CreateRole />,
  "approval-heirarchy": <ApprovalHeirarchy />,
  "materail-category": <MaterialCategory />,
  materails: <Materials />,
  uom: <UomPage />,
  "cost-center": <CostCenter />,
  "tax-master": <TaxMaster />,
  "labour-master": <LabourMaster />,
  "gate-entry": <GateEntry />,
  "brand-master": <BrandMaster />,
  "machineryTool-master": <ToolMaster />,
  "location-master": <LocationMaster />,
  "sitebreakdown-master": <SiteMaster />,
  "sitebreakdown-view/:id": <SitesStructureViewDetails />,
  "sitebreakdown-master/create": <SiteMasterFormImproved />,
  "general-ledger": <GeneralLedger />,
  "orgSettings": <Settings />,
};

const menu = [
  {
    text: "Dashboard",
    link: "tender/dashboard",
  },
  {
    text: "Tender",
    subMenu: [
      {
        text: "Create Tender",
        link: "tender/new-tender",
      },
      {
        text: "Tender List",
        link: "tender/tender-list",
      },
      {
        text: "Pending Approvals",
        link: "tender/pending-approvals",
      },
      {
        text: "Tender Evaluation",
        link: "tender-evaluation",
      },
      {
        text: "Tender Analysis",
        link: "tender/bafo-list",
      },
      // {
      //   text: "Contracts",
      //   link: "contract-list",
      // },
    ],
  },
  // {
  //   text: "Masters",
  //   subMenu: [
  //     {
  //       text: "Organisation",
  //       active: false,
  //       subMenu: [
  //         {
  //           text: "Organisation",
  //           link: "organisation",
  //         },
  //         {
  //           text: "Sites",
  //           link: "sites",
  //         },
  //         {
  //           text: "Site Break Down Structure",
  //           link: "sitebreakdown-master",
  //         },
  //         {
  //           text: "Sequence Settings",
  //           link: "sequence",
  //         },
  //       ],
  //     },
  //     {
  //       text: "Organization Structure",
  //       active: false,
  //       subMenu: [
  //         {
  //           text: "Departments",
  //           link: "departments",
  //         },
  //         {
  //           text: "Roles",
  //           link: "roles",
  //         },
  //         {
  //           text: "Organisation Structure",
  //           link: "reporting-hierarchy",
  //         },
  //         {
  //           text: "Approval Hierarchy",
  //           link: "approval-heirarchy",
  //         },
  //       ],
  //     },
  //     {
  //       text: "Users",
  //       link: "users",
  //     },
  //     {
  //       text: "Suppliers",
  //       active: false,
  //       subMenu: [
  //         {
  //           text: "Material Category",
  //           link: "supplier-category",
  //         },
  //         {
  //           text: "Suppliers",
  //           link: "suppliers",
  //         },
  //       ],
  //     },
  //     {
  //       text: "General Contractors",
  //       link: "general-contractors",
  //     },
  //     {
  //       text: "Client Master",
  //       link: "clients",
  //     },
  //     {
  //       text: "Consultants",
  //       link: "consultants",
  //     },
  //     {
  //       text: "Materials",
  //       active: false,
  //       subMenu: [
  //         {
  //           text: "UOM",
  //           link: "uom",
  //           alt: ["uom"],
  //         },
  //         {
  //           text: "Materials",
  //           link: "materails",
  //         },
  //         {
  //           text: "Brand Master",
  //           link: "brand-master",
  //         },
  //       ],
  //     },
  //     {
  //       text: "Works",
  //       active: false,
  //       subMenu: [
  //         {
  //           text: "Work Category",
  //           link: "work-category",
  //         },
  //         {
  //           text: "Work UOM",
  //           link: "work-uom",
  //         },
  //       ],
  //     },
  //     {
  //       text: "Tax Master",
  //       link: "tax-master",
  //     },
  //     {
  //       text: "Cost Center",
  //       link: "cost-center",
  //     },
  //     {
  //       text: "General Ledger",
  //       link: "general-ledger",
  //     },
  //   ],
  // },
];

const Pages = ({ setIsLoggedIn }) => {
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (
      !currentUser &&
      isAuthenticated &&
      !globalRoutes?.includes(window.location.pathname)
    ) {
      dispatch(fetchCurrentUser());
      dispatch(verifyAgentAccess());
      dispatch(verifySmartMapperAccess());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        const decodedString = atob(userRoutePermissions);
        // const decodedData = JSON.parse(decodedString);
        const decodedData = {
          KYC: {
            menuItem: "KYC",
            access: true,
            routes: [
              { path: "kyc-list-regular", permission: true, pageType: "view" },
              {
                path: "pms/Checklist/checklist-lists",
                permission: true,
                pageType: "view",
              },
              {
                path: "pages/checklist/create",
                permission: true,
                pageType: "view",
              },
              {
                path: "pages/checklist/edit",
                permission: true,
                pageType: "view",
              },
              {
                path: "kyc-details-regular/:kycId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Transactions: {
            menuItem: "Transactions",
            access: true,
            routes: [
              { path: "transaction-basic", permission: true, pageType: "view" },
              {
                path: "transaction-crypto",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Products: {
            menuItem: "Products",
            access: true,
            routes: [
              { path: "product-list", permission: true, pageType: "view" },
              { path: "product-card", permission: true, pageType: "view" },
              {
                path: "product-details/:productId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Pages: {
            menuItem: "Pages",
            access: true,
            routes: [
              { path: "terms-policy", permission: true, pageType: "view" },
              { path: "faq", permission: true, pageType: "view" },
              { path: "regular-v1", permission: true, pageType: "view" },
              { path: "regular-v2", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Authentication: {
            menuItem: "Authentication",
            access: true,
            routes: [
              { path: "auth-success", permission: true, pageType: "view" },
              { path: "auth-reset", permission: true, pageType: "view" },
              { path: "auth-register", permission: true, pageType: "add" },
              { path: "setPassword", permission: true, pageType: "add" },
              { path: "success", permission: true, pageType: "view" },
              { path: "errorEmail", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Errors: {
            menuItem: "Errors",
            access: true,
            routes: [
              { path: "errors/404-modern", permission: true, pageType: "view" },
              {
                path: "errors/404-classic",
                permission: true,
                pageType: "view",
              },
              { path: "errors/504-modern", permission: true, pageType: "view" },
              {
                path: "errors/504-classic",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Dashboard: {
            menuItem: "Dashboard",
            access: true,
            routes: [
              { path: "dashboard", permission: true, pageType: "view" },
              { path: "tender/dashboard", permission: true, pageType: "view" },
              // { path: "pms/projects", permission: true, pageType: "view" },

              {
                path: "tender/new-tender",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender/tender-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender/view-tender/:tenderID",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender/bafo-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender/bafo-analysis/:tenderID",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender/pending-approvals",
                permission: true,
                pageType: "view",
              },
              {
                path: "tender-evaluation",
                permission: true,
                pageType: "view",
              },
              {
                path: "contract-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "contracts-view/:id",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Master: {
            menuItem: "Master",
            access: true,
            routes: [
              { path: "organisation", permission: true, pageType: "view" },
              {
                path: "orgLegalInformation",
                permission: true,
                pageType: "view",
              },
              {
                path: "orgContactInformation",
                permission: true,
                pageType: "view",
              },
              {
                path: "orgBankInformation",
                permission: true,
                pageType: "view",
              },
              { path: "sites", permission: true, pageType: "view" },
              { path: "createSites", permission: true, pageType: "add" },
              { path: "delivery-address", permission: true, pageType: "view" },
              { path: "sequence", permission: true, pageType: "view" },
              {
                path: "sitesViewDetails/:siteId",
                permission: true,
                pageType: "view",
              },
              { path: "departments", permission: true, pageType: "view" },
              { path: "roles", permission: true, pageType: "view" },
              {
                path: "ViewRoleDetails/:roleID",
                permission: true,
                pageType: "view",
              },
              {
                path: "reporting-hierarchy",
                permission: true,
                pageType: "view",
              },
              { path: "supplier-category", permission: true, pageType: "view" },
              { path: "suppliers", permission: true, pageType: "view" },
              { path: "addSuppliers", permission: true, pageType: "add" },
              {
                path: "vewSuppliersDetails/:siteId",
                permission: true,
                pageType: "view",
              },
              {
                path: "general-contractors",
                permission: true,
                pageType: "view",
              },
              {
                path: "viewContractorDetails/:siteId",
                permission: true,
                pageType: "view",
              },
              { path: "addContractors", permission: true, pageType: "add" },
              { path: "addConsultants", permission: true, pageType: "add" },
              {
                path: "viewConsultantDetails/:consultantId",
                permission: true,
                pageType: "view",
              },
              { path: "addMaterials", permission: true, pageType: "add" },
              {
                path: "vewMaterialDetails/:materialId",
                permission: true,
                pageType: "view",
              },
              { path: "consultants", permission: true, pageType: "view" },
              { path: "users", permission: true, pageType: "view" },
              { path: "createUsers", permission: true, pageType: "add" },
              {
                path: "userProfile/:userId",
                permission: true,
                pageType: "view",
              },
              { path: "createRole", permission: true, pageType: "add" },
              {
                path: "approval-heirarchy",
                permission: true,
                pageType: "view",
              },
              { path: "materail-category", permission: true, pageType: "view" },
              { path: "materails", permission: true, pageType: "view" },
              { path: "cost-center", permission: true, pageType: "view" },
              { path: "general-ledger", permission: true, pageType: "view" },
              { path: "uom", permission: true, pageType: "view" },
              { path: "tax-master", permission: true, pageType: "view" },
              { path: "work-category", permission: true, pageType: "view" },
              { path: "work-uom", permission: true, pageType: "view" },
              { path: "labour-master", permission: true, pageType: "view" },
              { path: "machineryTool-master", permission: true, pageType: "view" },
              { path: "gate-entry", permission: true, pageType: "view" },
              { path: "brand-master", permission: true, pageType: "view" },
              { path: "location-master", permission: true, pageType: "view" },
              { path: "sitebreakdown-master", permission: true, pageType: "view" },
              { path: "sitebreakdown-view/:id", permission: true, pageType: "view" },
              { path: "sitebreakdown-master/create", permission: true, pageType: "add" },
              { path: "clients", permission: true, pageType: "view" },
              { path: "addClients", permission: true, pageType: "add" },
              { path: "viewClientDetails/:siteId", permission: true, pageType: "view" },
              { path: "orgSettings", permission: true, pageType: "view" },
              {
                path: "pages/terms-policy",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          "Purchase Request": {
            menuItem: "Purchase Request",
            access: true,
            routes: [
              {
                path: "add-new-purchase-request",
                permission: true,
                pageType: "add",
              },
              {
                path: "approvals-purchase-request",
                permission: true,
                pageType: "approve",
              },
              {
                path: "view-purchase-requests",
                permission: true,
                pageType: "view",
              },
              {
                path: "track-purchase-requests/:prId",
                permission: true,
                pageType: "view",
              },
              {
                path: "analytics-purchase-requests",
                permission: true,
                pageType: "view",
              },
              { path: "view_pr/:prId", permission: true, pageType: "view" },
              { path: "track-list", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Budget: {
            menuItem: "Budget",
            access: true,
            routes: [
              { path: "new-budget", permission: true, pageType: "add" },
              {
                path: "budget-approvals",
                permission: true,
                pageType: "approve",
              },
              { path: "view-budget", permission: true, pageType: "view" },
              {
                path: "pendingApproval-budget",
                permission: true,
                pageType: "approve",
              },
              { path: "track-budget", permission: true, pageType: "view" },
              { path: "analytics-budget", permission: true, pageType: "view" },
              {
                path: "view_budget_details/:budgetId",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Quotations: {
            menuItem: "Quotations",
            access: true,
            routes: [
              { path: "new-rfq", permission: true, pageType: "add" },
              { path: "rfq-approvals", permission: true, pageType: "approve" },
              { path: "qc-approvals", permission: true, pageType: "approve" },
              { path: "view-rfqs", permission: true, pageType: "view" },
              { path: "qc-list", permission: true, pageType: "view" },
              { path: "track-rfqs", permission: true, pageType: "view" },
              { path: "analytics-rfq", permission: true, pageType: "view" },
              { path: "rfq-comparison", permission: true, pageType: "view" },
              { path: "rfq-conversion", permission: true, pageType: "view" },
              {
                path: "rfq-supplier-responses",
                permission: true,
                pageType: "view",
              },
              { path: "rfq-full-view", permission: true, pageType: "view" },
              { path: "ready-to-award", permission: true, pageType: "view" },
              { path: "view/:qid", permission: true, pageType: "view" },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          "Purchase Order": {
            menuItem: "Purchase Order",
            access: true,
            routes: [
              { path: "purchase-order-new", permission: true, pageType: "add" },
              {
                path: "approvals-purchase-order",
                permission: true,
                pageType: "approve",
              },
              {
                path: "approvals-purchase-order/:orderNumber",
                permission: true,
                pageType: "approve",
              },
              {
                path: "view-purchase-order",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-purchase-order/:orderNumber",
                permission: true,
                pageType: "view",
              },
              {
                path: "track-purchase-order",
                permission: true,
                pageType: "view",
              },
              {
                path: "analytics-purchase-order",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          "Credit Note": {
            menuItem: "Credit Note",
            access: true,
            routes: [
              {
                path: "credit-debit-note-new",
                permission: true,
                pageType: "add",
              },
              {
                path: "all-credit-debit-notes",
                permission: true,
                pageType: "view",
              },
              {
                path: "pending-approval-credit-debit-notes",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Invoice: {
            menuItem: "Invoice",
            access: true,
            routes: [
              { path: "invoice-payables", permission: true, pageType: "view" },
              {
                path: "add-purchase-invoice/:orderNumber",
                permission: true,
                pageType: "add",
              },
              {
                path: "view-material-invoices/:orderNumber/:lineNo",
                permission: true,
                pageType: "view",
              },
              { path: "view-invoice-list", permission: true, pageType: "view" },
              { path: "view-invoice/:id", permission: true, pageType: "view" },
              {
                path: "approvals-purchase-invoice",
                permission: true,
                pageType: "approve",
              },
              {
                path: "analytics-purchase-invoice",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Payments: {
            menuItem: "Payments",
            access: true,
            routes: [
              {
                path: "pending-payment-approvals",
                permission: true,
                pageType: "approve",
              },
              { path: "run-payments", permission: true, pageType: "add" },
              { path: "view-payments", permission: true, pageType: "view" },
              { path: "payment-analytics", permission: true, pageType: "view" },
              {
                path: "payments-analytics",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Dispatch: {
            menuItem: "Dispatch",
            access: true,
            routes: [
              {
                path: "view-dispatch-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "delivered-dispatch-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-dispatch-details/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "pending-approvals-grn-list",
                permission: true,
                pageType: "approve",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          "Material Issue": {
            menuItem: "Material Issue",
            access: true,
            routes: [
              { path: "material-issue", permission: true, pageType: "add" },
              {
                path: "inventory-pending-approvals",
                permission: true,
                pageType: "approve",
              },
              { path: "site-inventory", permission: true, pageType: "view" },
              {
                path: "material-issue-details/:materialIssueId",
                permission: true,
                pageType: "view",
              },
              {
                path: "materialIssue-pending-approvals",
                permission: true,
                pageType: "view",
              },
              {
                path: "stock-availability",
                permission: true,
                pageType: "view",
              },
              {
                path: "dashboard-inventory",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          BOQ: {
            menuItem: "BOQ",
            access: true,
            routes: [
              {
                path: "create-consumption-target",
                permission: true,
                pageType: "add",
              },
              {
                path: "view-consumption-target/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "consumption-target-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "consumption-target-Report",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
          Reports: {
            menuItem: "Reports",
            access: true,
            routes: [
              {
                path: "view-purchase-reports",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-accounts-payable-reports",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-order-report-preview/:orderNumber",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-order-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-supplier-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-supplier-detail-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-material-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-material-reports-detail-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-category-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "order-details-by-category-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-details-by-category-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "purchase-by-site-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "order-details-by-site-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-details-by-site-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-by-supplier-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-preview-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "delivery-note-details",
                permission: true,
                pageType: "view",
              },
              {
                path: "materials-by-delivery-note-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "supplier-payments-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "supplier-payments-invoice-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "payment-aging-summary-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "payment-aging-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "payment-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "view-inventory-reports",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-approved-material-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-materials-to-site-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-summary-reports-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-committed-stock-report-list/:id/:historyId",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-track-report-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-aging-report-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-material-utilization-report-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-abc-classification-report-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-value-report-list",
                permission: true,
                pageType: "view",
              },
              {
                path: "inventory-value-report-preview/:id/:historyId",
                permission: true,
                pageType: "view",
              },
              {
                path: "payments-aging-summary-invoice-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "supplier-balances-report",
                permission: true,
                pageType: "view",
              },
              {
                path: "supplierBalancesDetailReport/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "grn-preview-report/:id",
                permission: true,
                pageType: "view",
              },
              {
                path: "invoice-details-for-payments-report/:id",
                permission: true,
                pageType: "view",
              },
            ],
            add: 1,
            view: 1,
            edit: 1,
            approve: 1,
            reject: 1,
            cancel: 1,
          },
        };
        console.log("decodedData", decodedData);
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });
        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);
        const _menu = [];
        menu?.forEach((item) => {
          if (item?.subMenu?.length > 0) {
            const subMenu = [];
            item?.subMenu?.forEach((subItem) => {
              if (subItem?.subMenu?.length > 0) {
                const _subMenuChildren = [];
                subItem?.subMenu?.forEach((subSubItem) => {
                  if (_allowedRoutes.includes(subSubItem?.link)) {
                    _subMenuChildren.push({
                      text: subSubItem?.text,
                      link: subSubItem?.link,
                      icon: subSubItem?.icon,
                    });
                  }
                });
                if (_subMenuChildren.length > 0) {
                  subMenu.push({
                    text: subItem?.text,
                    icon: subItem?.icon,
                    active: false,
                    subMenu: _subMenuChildren,
                  });
                }
                return;
              }
              if (_allowedRoutes.includes(subItem?.link)) {
                subMenu.push({
                  text: subItem?.text,
                  icon: subItem?.icon,
                  link: subItem?.link,
                });
              } else {
                if (subItem?.alt?.length > 0) {
                  const altLink = subItem?.alt?.find((link) =>
                    _allowedRoutes.includes(link)
                  );
                  if (altLink) {
                    subMenu.push({
                      text: subItem?.text,
                      icon: subItem?.icon,
                      link: altLink,
                    });
                  }
                }
              }
            });
            if (subMenu.length > 0) {
              _menu.push({
                text: item?.text,
                subMenu: subMenu,
                icon: item?.icon,
              });
            }
          } else {
            if (_allowedRoutes.includes(item?.link)) {
              _menu.push({
                text: item?.text,
                link: item?.link,
                icon: item?.icon,
              });
            } else if (item?.alt?.length > 0) {
              const altLink = item?.alt?.find((link) =>
                _allowedRoutes.includes(link)
              );
              if (altLink) {
                _menu.push({
                  text: item?.text,
                  icon: item?.icon,
                  link: altLink,
                });
              }
            }
          }
        });
        console.log("_allowedRoutes", _allowedRoutes);
        if (!_allowedRoutes?.includes("dashboard")) {
          console.log("_allowedRoutes", _allowedRoutes?.includes("dashboard"));
          _menu.unshift({
            text: "",
            link: "home",
            icon: <HomeOutlined style={{ fontSize: "18px" }} />,
          });
        }
        dispatch(updateMenuData(_menu));
        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (!isAuthenticated && !globalRoutes?.includes(window.location.pathname)) {
      window.location.href = "/";
    }
  }, []);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        {accessibility?.map(
          (path) =>
            tenderManagementRouts[path] && (
              <Route
                key={path}
                path={path}
                element={tenderManagementRouts[path]}
              />
            )
        )}
        {restrictedRoutes?.map((path) => (
          <Route path={path} element={<div> Unauthorized Access</div>} />
        ))}
        {/* Ensure this route is above any wildcard or catch-all */}
        <Route
          path="tender-evaluation/:tenderId"
          element={<SupplierDetailsPage />}
        />
        <Route
          path="tender-evaluation/:tenderId/supplier/:supId"
          element={<SupplierViewPage />}
        />
        <Route path="notifications" element={<NotificationMain />} />
        {/* <Route path="viewhistory" element={<VersionControlDefaultTemplate />} /> */}
        <Route path="privacy" element={<Faq />}></Route>
        <Route path="terms-policy" element={<Terms />}></Route>
        <Route
          path="user-profile-regular"
          element={<UserProfileRegular />}
        ></Route>
        <Route
          path="user-profile-notification"
          element={<UserProfileNotification />}
        ></Route>
        <Route
          path="user-profile-activity"
          element={<UserProfileActivity />}
        ></Route>
        <Route
          path="user-profile-setting"
          element={<UserProfileSetting />}
        ></Route>
        <Route
          path="excelexport-requested-list"
          element={<ExcelExportRequestedList />}
        ></Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ResetPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>
        <Route path="setPassword" element={<SetPassword />}></Route>
        <Route path="success" element={<SuccessMain />}></Route>
        <Route path="errorEmail" element={<EmailError />}></Route>

        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
